import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";
import {FC, PropsWithChildren} from "react";

type ButtonOverlayProps = PropsWithChildren<{
    opacity: number
}>

const StyledButtonOverlay = styled(Box)<ButtonOverlayProps>(({opacity = 0, theme}) => ({
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translate(-50%, 0)',
    background: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: opacity,
    transition: 'opacity 0.3s ease-in-out',
    width: '100%',
}))

const ButtonGrid = styled(Box)({
    margin: 10,
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    button: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',

        span: {
            '@media (max-width: 768px)': {
                display: 'none',
            },
            paddingLeft: 10,
            textAlign: 'left'
        },

        '.MuiSvgIcon-root': {
            fontSize: '2rem',
        },
    }
})

const ButtonOverlay: FC<ButtonOverlayProps> = ({children, ...props}) => (
    <StyledButtonOverlay className="overlay" {...props}>
        <ButtonGrid>
            {children}
        </ButtonGrid>
    </StyledButtonOverlay>
)

export default ButtonOverlay;
